import React from 'react';
import { Section } from './Section';
import { BookOpenIcon, HeartPulseIcon, ClockIcon, SparklesIcon } from 'lucide-react';
const features = [{
  icon: <BookOpenIcon className="w-8 h-8" data-id="element-262" />,
  title: '+40 Recetas Completas',
  desc: 'Desayunos, almuerzos, cenas y snacks diseñados para todo el día, sin que tengas que pensar qué cocinar.'
}, {
  icon: <HeartPulseIcon className="w-8 h-8" data-id="element-263" />,
  title: 'Adaptado a tu Tiroides',
  desc: 'Ingredientes seleccionados específicamente para apoyar condiciones como Hipotiroidismo, Hipertiroidismo y Hashimoto.'
}, {
  icon: <SparklesIcon className="w-8 h-8" data-id="element-264" />,
  title: 'Postres sin Culpa',
  desc: 'Opciones dulces y deliciosas que no inflaman ni alteran tu metabolismo. Disfruta sin remordimientos.'
}, {
  icon: <ClockIcon className="w-8 h-8" data-id="element-265" />,
  title: 'Fáciles y Rápidas',
  desc: 'Preparaciones simples con ingredientes que consigues en cualquier supermercado local. Cero complicaciones.'
}];
export const Solution = () => {
  return <Section className="bg-stone-900 text-stone-50" data-id="element-266">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-267">
        <span className="text-brand-400 font-semibold tracking-wider uppercase text-sm mb-2 block" data-id="element-268">
          La Solución
        </span>
        <h2 className="text-3xl md:text-4xl font-bold mb-6 text-white" data-id="element-269">
          Te presentamos: Plan Tiroides 360
        </h2>
        <p className="text-lg text-stone-300" data-id="element-270">
          El recetario digital definitivo que transforma la nutrición tiroidea
          en platos deliciosos, fáciles de preparar y que toda tu familia querrá
          comer.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-271">
        {features.map((feature, idx) => <div key={idx} className="text-center flex flex-col items-center" data-id="element-272">
            <div className="w-16 h-16 bg-stone-800 text-brand-400 rounded-2xl flex items-center justify-center mb-6 shadow-inner" data-id="element-273">
              {feature.icon}
            </div>
            <h3 className="text-xl font-bold mb-3 text-white" data-id="element-274">
              {feature.title}
            </h3>
            <p className="text-stone-400 leading-relaxed text-sm" data-id="element-275">
              {feature.desc}
            </p>
          </div>)}
      </div>
    </Section>;
};